export default "__VITE_ASSET__CVJthJQw__"